import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import '../styles/Navbar.css';
import { fetchUserId, fetchRole, fetchUserName, fetchCompanyId } from '../helpers/CompanyId';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import api from '../api';
import publicApi from '../publicApi';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';

const Navbar = () => {
  const [companyName, setCompanyName] = useState('Company Name');
  const [companyLogo, setCompanyLogo] = useState();
  const [error, setError] = useState(null); 
  const [userName, setUserName] = useState('');
  const [role, setRole] = useState('');
  const [showModal, setShowModal] = useState(false); // Modal state
  const navigate = useNavigate();

  // useEffect(() => {
  //   const fetchCompanyDetails = async () => {
  //     try {
  //       const userId = await fetchUserId();
  //       if (!userId) {
  //         setError('User ID not found');
  //         return;
  //       }
  
  //       const role = await fetchRole();
  //       if (!role) {
  //         setError('Role not found');
  //         return;
  //       }
  
  //       setRole(role); // Store role in the state
  
  //       const userName = await fetchUserName(userId);
  //       if (!userName) {
  //         setError('Username not found');
  //         return;
  //       }
  
  //       setUserName(userName); // Store username in the state
  //       // Fetch user details to check if company setup is complete
  //       const userDetailsResponse = await api.get(`/api/getuserdetails/${userId}/`);
  //       if (!userDetailsResponse || !userDetailsResponse.data) {
  //         setError('User details not found');
  //         return;
  //       }
  
  //       const isCompanySetupComplete = userDetailsResponse.data.is_company_setup_complete;
  //       // Check if company setup is complete before proceeding
  //       if (isCompanySetupComplete) {
  //         // Proceed with fetching company details only if setup is complete
  //         const companyId = await fetchCompanyId(userId);
  //         if (!companyId) {
  //           setError('Company ID not found');
  //           return;
  //         }
  
  //         // Fetch company details
  //         const response = await api.get(`/api/companydetails/retrieve/${companyId}/`);
  //         const companyDetails = response.data;
  //         setCompanyName(companyDetails.companyName || 'Company Name');
  //         if (companyDetails.logo_url) {
  //           const baseUrl = publicApi.defaults.baseURL; // Get the base URL from publicApi
  //           setCompanyLogo(`${baseUrl}${companyDetails.logo_url}`);
  //         }
  //       } else {
  //         // If company setup is not complete, set an appropriate message or handle it
  //         console.log('Company setup is not complete. Redirecting to setup page.');
  //         // navigate('/companysetup');  // Redirect to company setup page if needed
  //       }
  
  //     } catch (error) {
  //       console.error('Error fetching company details:', error);
  //       setError('An error occurred while fetching company details');
  //     }
  //   };
  
  //   fetchCompanyDetails();
  // }, [navigate]);  // Ensure to trigger when navigate changes
  

  useEffect(() => {
    const fetchCompanyDetails = async () => {
      try {
        const userId = await fetchUserId();
        if (!userId) {
          setError('User ID not found');
          return;
        }

        const role = await fetchRole();
        if (!role) {
          setError('Role not found');
          return;
        }

        setRole(role); // Store role in the state

        const userName = await fetchUserName(userId);
        if (!userName) {
          setError('Username not found');
          return;
        }

        setUserName(userName); // Store username in the state

        if (role === 'Super Admin') {
          // Set Solivar details for Super Admin
          setCompanyName('Solivar');
          setCompanyLogo('logo.png');
          } else {
          const companyId = await fetchCompanyId(userId);
          if (!companyId) {
            setError('Company ID not found');
            return;
          }

        // Fetch company details
        const response = await api.get(`/api/companydetails/retrieve/${companyId}/`);
        const companyDetails = response.data;
        setCompanyName(companyDetails.companyName || 'Company Name');
        if (companyDetails.logo_url) {
          const baseUrl = publicApi.defaults.baseURL; // Get the base URL from publicApi
          setCompanyLogo(`${baseUrl}${companyDetails.logo_url}`);
        }
      }
      
      } catch (error) {
        console.error('Error fetching company details:', error);
      }
    };

    fetchCompanyDetails();
  }, [navigate]);

  const handleLogout = () => {
    localStorage.clear();
    navigate('/login');
  };

  return (
    <nav className="navbar">
      <div className="navbar-left">
      {companyLogo && (
          <img src={companyLogo} alt="logo" className="company-logo" />
        )}
      </div>

      <div className="navbar-center">
        <h1 className="company-name">{companyName}</h1>
      </div>

      <div className="navbar-right">
        <ul className="navbar-links">
          <li>
            <Link to="/Home1">Dashboard</Link>
          </li>
        </ul>

       
        <div className="navbar-profile">
          <AccountCircleIcon
            className="profile-icon"
            style={{ fontSize: '3rem', cursor: 'pointer' }}
            onClick={() => setShowModal((prev) => !prev)} // Toggle modal visibility
          />
          {showModal && (
            <div className="modal-below-icon">
              <AccountCircleIcon  style={{ fontSize: '4rem' }} />

              <p><strong>Name:</strong> {userName}</p>
              <p><strong>Role:</strong> {role}</p>
              
            </div>
          )}
        </div>

        <div className="navbar-logout">
          <ExitToAppIcon
            className="profile-icon"
            style={{ fontSize: '2.8rem', cursor: 'pointer'  }}
            onClick={handleLogout} />
        </div>

      </div>
    </nav>
  );
};

export default Navbar;

